import React from 'react';
import { Link } from 'react-router-dom';

const CookiePolicy = () => (
  <div className="bg-black text-white pt-24">
    <div className="bg-gradient-to-br from-black to-gray-900 py-16">
      <div className="container mx-auto px-6 text-center">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Cookie <span className="text-[#F4B400]">Policy</span></h1>
        <p className="text-gray-400">Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</p>
      </div>
    </div>
    <div className="bg-white text-black py-16">
      <div className="container mx-auto px-6 max-w-4xl prose prose-lg">
        <h2 className="text-2xl font-bold mt-8 mb-4">1. What Are Cookies</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          Cookies are small text files stored on your device when you visit a website. They help the website remember your preferences, understand how you use the site, and improve your experience.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">2. How We Use Cookies</h2>
        <p className="text-gray-700 leading-relaxed mb-4">Enrigo Studio (ealagon.com) uses cookies for the following purposes:</p>

        <h3 className="text-xl font-semibold mt-6 mb-3">Essential Cookies</h3>
        <p className="text-gray-700 leading-relaxed mb-4">
          These cookies are necessary for the website to function properly. They enable core features like user authentication, shopping cart, and security. You cannot opt out of essential cookies.
        </p>
        <div className="overflow-x-auto mb-6">
          <table className="w-full border-collapse border border-gray-300 text-sm">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left">Cookie</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Purpose</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Duration</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-2">auth_token</td>
                <td className="border border-gray-300 px-4 py-2">User authentication session</td>
                <td className="border border-gray-300 px-4 py-2">7 days</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">cookie_consent</td>
                <td className="border border-gray-300 px-4 py-2">Stores your cookie preferences</td>
                <td className="border border-gray-300 px-4 py-2">365 days</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="text-xl font-semibold mt-6 mb-3">Analytics Cookies</h3>
        <p className="text-gray-700 leading-relaxed mb-4">
          These cookies help us understand how visitors interact with our website by collecting and reporting anonymous information.
        </p>
        <div className="overflow-x-auto mb-6">
          <table className="w-full border-collapse border border-gray-300 text-sm">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left">Cookie</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Provider</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Purpose</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Duration</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-2">_ga, _ga_*</td>
                <td className="border border-gray-300 px-4 py-2">Google Analytics</td>
                <td className="border border-gray-300 px-4 py-2">Distinguish unique users and sessions</td>
                <td className="border border-gray-300 px-4 py-2">2 years</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">_gid</td>
                <td className="border border-gray-300 px-4 py-2">Google Analytics</td>
                <td className="border border-gray-300 px-4 py-2">Store and count page views</td>
                <td className="border border-gray-300 px-4 py-2">24 hours</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 className="text-xl font-semibold mt-6 mb-3">Advertising Cookies</h3>
        <p className="text-gray-700 leading-relaxed mb-4">
          These cookies are used to display relevant advertisements to you. They track your browsing activity across websites to deliver personalized ads.
        </p>
        <div className="overflow-x-auto mb-6">
          <table className="w-full border-collapse border border-gray-300 text-sm">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 text-left">Cookie</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Provider</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Purpose</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 px-4 py-2">__gads, __gpi</td>
                <td className="border border-gray-300 px-4 py-2">Google AdSense</td>
                <td className="border border-gray-300 px-4 py-2">Serve and measure ad effectiveness</td>
              </tr>
              <tr>
                <td className="border border-gray-300 px-4 py-2">IDE, DSID</td>
                <td className="border border-gray-300 px-4 py-2">Google DoubleClick</td>
                <td className="border border-gray-300 px-4 py-2">Ad personalization and retargeting</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2 className="text-2xl font-bold mt-8 mb-4">3. Google AdSense</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          We use Google AdSense to display advertisements on our website. Google and its partners use cookies to serve ads based on your prior visits to our website or other websites. You can opt out of personalized advertising by visiting <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer" className="text-[#F4B400] hover:underline">Google Ads Settings</a> or <a href="https://www.aboutads.info/choices/" target="_blank" rel="noopener noreferrer" className="text-[#F4B400] hover:underline">aboutads.info</a>.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">4. Managing Cookies</h2>
        <p className="text-gray-700 leading-relaxed mb-4">You can manage your cookie preferences in several ways:</p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
          <li><strong>Cookie consent banner:</strong> Use the cookie consent popup that appears when you first visit our site to accept or customize your preferences.</li>
          <li><strong>Browser settings:</strong> Most browsers allow you to block or delete cookies through their settings.</li>
          <li><strong>Google opt-out:</strong> Visit <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-[#F4B400] hover:underline">Google Analytics Opt-out</a> to install the browser add-on.</li>
          <li><strong>Ad personalization:</strong> Visit <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer" className="text-[#F4B400] hover:underline">Google Ads Settings</a> to manage ad preferences.</li>
        </ul>
        <p className="text-gray-700 leading-relaxed mb-4">
          Note: Disabling certain cookies may affect the functionality of our website.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">5. Updates to This Policy</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          We may update this Cookie Policy periodically. Any changes will be posted on this page.
        </p>

        <h2 className="text-2xl font-bold mt-8 mb-4">6. Contact Us</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          If you have questions about our use of cookies, contact us:
        </p>
        <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4">
          <li>Email: <a href="mailto:enrigo@ealagon.com" className="text-[#F4B400] hover:underline">enrigo@ealagon.com</a></li>
          <li>Phone: <a href="tel:+18608470649" className="text-[#F4B400] hover:underline">(860) 847-0649</a></li>
        </ul>

        <div className="mt-8 p-6 bg-gray-50 rounded-xl border border-gray-200">
          <p className="text-gray-600 text-sm">
            See also: <Link to="/privacy" className="text-[#F4B400] hover:underline">Privacy Policy</Link> | <Link to="/terms" className="text-[#F4B400] hover:underline">Terms of Service</Link>
          </p>
        </div>
      </div>
    </div>
  </div>
);

export default CookiePolicy;
